import script from "./whiteOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./whiteOverlay.vue?vue&type=script&setup=true&lang=js"

import "./whiteOverlay.vue?vue&type=style&index=0&id=1b8744d4&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b8744d4"]])

export default __exports__